import { error } from '@sveltejs/kit';
import { m } from '$lib/paraglide/messages';

import type { PageLoadEvent } from './$types';

import BrandPage from './BrandPage.svelte';

type BrandSummary = {
	name: string;
	slug: string;
	count: number;
};

export type BrandsPageData = {
	groupedBrands: Record<string, BrandSummary[]>;
};

const normalize = (brand: string) => brand.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const brandsLoad = async ({ fetch, parent, setHeaders }: PageLoadEvent) => {
	const { store } = await parent();
	const brands_response = await fetch(`/api/content/brands`, {
		headers: {
			'X-Store-ID': store.store_id.toString(),
		},
	});

	if (!brands_response.ok) {
		error(500);
	}

	const brands: BrandSummary[] = await brands_response.json();

	const groupedBrands: Record<string, BrandSummary[]> = {};
	for (const brand of brands) {
		const first = normalize(brand.name[0].toLowerCase());
		if (!groupedBrands[first]) groupedBrands[first] = [];
		groupedBrands[first].push(brand);
	}

	const sortedGroupedBrands: Record<string, BrandSummary[]> = {};
	Object.keys(groupedBrands)
		.sort()
		.forEach((key) => {
			sortedGroupedBrands[key] = groupedBrands[key].sort((a, b) => {
				const nameA = normalize(a.name.toLowerCase());
				const nameB = normalize(b.name.toLowerCase());
				return nameA.localeCompare(nameB);
			});
		});

	setHeaders({
		'cache-control': 'public, max-age=300',
	});

	const pageData: BrandsPageData = {
		groupedBrands: sortedGroupedBrands,
	};
	return {
		component: BrandPage,
		pageData: pageData,
		title: m.brands(),
	};
};
